import { createGlobalStyle } from 'styled-components';
import CheckPng from 'assets/img/check.png';
import {
  media, truncate, getZIndexes,
} from 'utils/styledHelpers';
import { StyledLabelInfoAndHint } from 'shared/ui/Info.styled';
import reset from 'styled-reset';

const {
  contentOverlayZIndex, antMessageZIndex, toxEditorZIndex,
} = getZIndexes();

export const previewDetailsWrapperWidth = 435;

const Global = createGlobalStyle`
  ${reset}
  html {
    height: 100%;
    font-size: 14px;
    font-family: ${(props) => props.theme.typography.fontFamilyBase};
    overflow: hidden;

    @media only screen and (max-width: 1366px) {
      font-size: 13px;
    }
    @media only screen and (max-width: 1280px) {
      font-size: 12px;
    }

    button, input, select, textarea {
      font-family: ${(props) => props.theme.typography.fontFamilyBase};
    }

    a {
      color: ${(props) => props.theme.colors.blue};
      text-decoration: none;
    }

    ${media.sm`
      overflow: hidden auto;
    `}
  }
  *:focus-visible {
    outline: none !important;
  }
  
  body {
    min-height: 100%;
    font-family: ${(props) => props.theme.typography.fontFamilyBase};
    line-height: normal;
    font-weight: ${(props) => props.theme.typography.fontWeightRegular};
    font-size: ${(props) => props.theme.typography.fontSizeDefault};
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    position: relative;
    background-color: ${(props) => props.theme.colors.primaryBg};
    color: ${(props) => props.theme.colors.primaryText};
  }

  #root {
    height: 100dvh;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    ${media.sm`
      overflow: visible;
    `}
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background-color: ${(props) => props.theme.colors.secondaryBorder}40;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.primaryBorder};
    border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
  }
  
  @supports not selector(::-webkit-scrollbar) {
    * {
      scrollbar-width: thin;
      scrollbar-color: ${(props) => props.theme.colors.primaryBorder} ${(props) => props.theme.colors.secondaryBg};
    }
  }
  
  ::selection {
    background-color: ${(props) => props.theme.colors.blue};
    color: #ffffff;
  }
  
  svg {
    display: block;
  }

  h1, h2, h3, h4, h5, h6, p {
    color: ${(props) => props.theme.colors.primaryText};
    line-height: unset;
  }

  strong {
    font-weight: ${(props) => props.theme.typography.fontWeightMedium} !important;
  }

  .ant-upload-list-item-info > span {
    display: flex;
    align-items: center;
  }

  html.app-html .ant-layout-content.no-padding {
    padding: 0;
  }

  .ant-select-item-option-selected .anticon-check {
    display: none;
  }

  .layout {
    min-height: calc(100vh - 200px) !important;
  }

  .ant-select-dropdown-menu-item-group {
    &-title {
      font-weight: ${(props) => props.theme.typography.fontWeightMedium};
      font-size: ${(props) => props.theme.typography.fontSizeDefault};
      padding-left: 16px;
    }

    .ant-select-dropdown-menu-item-group-list li {
      padding-left: 32px !important;
    }
  }

  .ant-form-item .ant-form-item-row .ant-col.ant-form-item-label > .ant-form-item-required:after,
  .ant-form-vertical .ant-col .ant-form-item .ant-form-item-label > .ant-form-item-required:after,
  .ant-form-horizontal .ant-col .ant-form-item .ant-form-item-label > .ant-form-item-required:after {
    display: inline-block;
    content: '*';
    visibility: visible;
  }
  

  .ant-checkbox {
    top: -0.1rem;
  }

  .ant-checkbox-wrapper {
    display: inline-flex;
    align-items: center;

    span {
      font-size: 1rem;
    }

    .ant-checkbox-input[disabled] + .ant-checkbox-inner {
      background-color: ${(props) => props.theme.colors.secondaryBg} !important;
    }

    color: ${(props) => props.theme.colors.primaryText};

    .ant-checkbox-disabled + span {
      color: ${(props) => props.theme.colors.filterLabelColor};
    }

    .ant-checkbox-checked:not(.ant-checkbox-indeterminate) {
      .ant-checkbox-inner {
        background-color: ${(props) => props.theme.colors.blue} !important;
        border: 1px solid ${(props) => props.theme.colors.blue};
      }

      .ant-checkbox-input[disabled] + .ant-checkbox-inner {
        background-color: ${(props) => props.theme.colors.blue}60 !important;
      }
    }

    .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
      border-color: ${(props) => props.theme.colors.white};
    }

    .ant-checkbox-inner,
    .ant-checkbox-indeterminate .ant-checkbox-inner {
      background-color: ${(props) => props.theme.colors.secondaryBg};
      border: 1px solid ${(props) => props.theme.colors.primaryBorder};
    }

    .ant-checkbox-input[disabled] + .ant-checkbox-inner {
      background-color: ${(props) => props.theme.colors.white};
      border-color: ${(props) => props.theme.colors.secondaryBorder} !important;
    }
  }

  .ant-card .ant-card-head {
    padding: 0 0 0 16px;
  }

  .ant-dropdown-menu-submenu-popup {
    padding: 0;

    ul {
      margin: 0 !important;
    }
  }

  .ant-form-item .ant-form-item-control-input {
    min-height: auto;
  }

  .draggable-columns table th {
    cursor: move !important;
    
    ${media.sm`
      cursor: auto !important;
    `}
  }
  .draggable-rows table tbody {
    td.drag-row-handle {
      cursor: move !important;
    }

    tr.drag-row-disabled td.drag-row-handle {
      pointer-events: none;
      opacity: 0.4;
    }
  }

  .dragging-col-custom {
    border-bottom: 2px dashed blue !important;
  }

  .draggable-columns table .ant-table-column-sorter {
    cursor: pointer !important;
    z-index: 1;
  }

  .ant-tooltip .ant-tooltip-container {
    min-height: initial;
    text-align: center;
    box-shadow: none;
  }

  .ant-tooltip-arrow-content, .ant-tooltip-container {
    color: ${(props) => props.theme.colors.white} !important;

    > div > span {
      color: ${(props) => props.theme.colors.white} !important;
    }
  }

  .ant-popover {
    .ant-popover-container {
      background-color: ${(props) => props.theme.colors.selectBg};
      border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusMiddle};
      padding: 0;
    }

    .ant-popover-title {
      font-size: 1rem;
      padding: 1rem 1.71rem;
      border-bottom: 1px solid ${(props) => props.theme.colors.secondaryBorder} !important;
      color: ${(props) => props.theme.colors.primaryText};
    }

    .ant-popover-content {
      border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
      padding: 0.3rem 0;
      word-break: break-word;
      font-size: ${(props) => props.theme.typography.fontSizeDefault};
      color: ${(props) => props.theme.colors.primaryText};
    }

    .ant-popover-arrow:before {
      background-color: ${(props) => props.theme.colors.selectBg};
    }
  }

  .ant-popover-content > .ant-popover-arrow {
    display: none;
  }

  .ant-input-search .ant-input-affix-wrapper {
    height: 100%;
  }

  .ant-input-search > .ant-input-group > .ant-input-group-addon, .ant-input-search > .ant-input-group > .ant-input-group-addon:last-child {
    left: auto;
    height: 100%;
    padding: 0;

    .ant-btn.ant-btn-icon-only.ant-input-search-button {
      height: 100%;
      padding: 0;
    }
  }

  .color-picker-popover.ant-popover {
      .ant-popover-container {
          .ant-color-picker-input {
              > span {
                  height: 100%;
              }
          }

          .ant-input-number {
              .ant-input-number-handler-wrap {
                  display: none !important;
              }
          }
      }
  }
  
  .description-popover {
    padding-top: 0;

    &-long {
      max-width: 50%;
    }

    .ant-popover-content {
      padding: 0.57rem 1.14rem;
      line-height: 22px;
    }
  }

  .dark-popover {
    .ant-popover-container, .ant-popover-arrow:before, .ant-popover-arrow:after {
      background-color: ${(props) => props.theme.colors.tertiaryBg};
    }
  }
  
  .ant-popover-arrow {
    display: none;
  }

  .ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled),
  .ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled) {
    background-color: ${(props) => props.theme.colors.blue}15;
  }

  .ant-calendar-picker-clear {
    background: transparent;
  }

  .ant-select-selection--multiple .ant-select-selection__rendered,
  .ant-select-selection__rendered {
    margin-left: 16px;
  }

  input.ant-input,
  textarea.ant-input {
      padding: 10px 1.14rem;
      border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
      &:focus {
          background-color: transparent;
      }
  }

  input.ant-input,
  span.ant-input-password, .ant-select {
    height: 100%;
  }

  .ant-select-item-option-content {
    font-size: ${(props) => props.theme.typography.fontSizeDefault};
  }

  .ant-select-show-search.ant-select-single:not(.ant-select-customize-input).ant-select-disabled .ant-select-selector {
    cursor: not-allowed;
  }

  .ant-table-wrapper .ant-table {
    background: transparent;
  }

  .ant-form-item-has-success, .ant-form-item {
    .ant-form .ant-form-item-control {
      &:hover .ant-input:not([disabled]),
      &:hover .ant-select-selection,
      & .ant-select-selection:hover {
        border-color: ${(props) => props.theme.colors.blue};
        box-shadow: 0 0 0 2px ${(props) => props.theme.colors.blue}30;
      }

      &:focus .ant-input:not([disabled]),
      .ant-input:not([disabled]):focus {
        border-color: ${(props) => props.theme.colors.blue};
        box-shadow: 0 0 0 2px ${(props) => props.theme.colors.blue}30;
      }

      &:focus:not(.ant-select-disabled) .ant-select-selection,
      &:not(.ant-select-disabled).ant-select-selection:focus {
        border-color: ${(props) => props.theme.colors.blue};
        box-shadow: 0 0 0 2px ${(props) => props.theme.colors.blue}30;
      }

      .ant-select-focused .ant-select-selection {
        border-color: ${(props) => props.theme.colors.blue};
        box-shadow: 0 0 0 2px ${(props) => props.theme.colors.blue}30;
      }
    }

    .ant-input:hover {
      border-color: ${(props) => props.theme.colors.blue};
    }

    .ant-input:focus {
      box-shadow: 0 0 0 2px ${(props) => props.theme.colors.blue}30;
    }
  }

  .dragging-row-custom {
    border-top: 1px dashed ${(props) => props.theme.colors.blue} !important;
    border-bottom: 1px dashed ${(props) => props.theme.colors.blue} !important;
  }

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector,
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
    height: 100%;
  }

  .ant-select-disabled.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    background: ${(props) => props.theme.colors.white};
  }

  .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    padding-right: 1.29rem;
    font-size: 1rem;
    span{
      height: 100%;
    }
  }

  .ant-select-selection-wrap .ant-select-single .ant-select-selector .ant-select-selection-search {
    left: 1.14rem;
  }

  .ant-form-item-explain {
    margin: 0;
    width: 100%;

    > div {
      background: ${(props) => props.theme.colors.red};
      border: 1px solid #c30909;
      border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
      box-sizing: border-box;

      span {
        color: ${(props) => props.theme.colors.primaryText};
      }
        
        &:empty {
            display: none;
        }
    }
  }

  .ant-select-item-group {
    font-weight: ${(props) => props.theme.typography.fontWeightMedium};
    font-size: ${(props) => props.theme.typography.fontSizeDefault};
    color: ${(props) => props.theme.colors.primaryText};
  }

  .ant-select .ant-select-clear, .ant-picker .ant-picker-clear {
    width: 1.14rem;
    height: 1.14rem;
    margin-top: 0;
    transform: translateY(-50%);
    background: ${(props) => props.theme.colors.secondaryBg};

    > span {
      width: 100%;
      height: 100%;

      > svg {
        width: 100%;
        height: 100%;
        color: ${(props) => props.theme.colors.secondaryColor}90;
      
        &:hover {
          color: ${(props) => props.theme.colors.secondaryColor};
        }
      }
    }
  }

  ::-webkit-scrollbar {
    background: ${(props) => props.theme.colors.primaryBg}30;
  }

  .ant-checkbox-inner {
    border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusDefault};
  }

  .ant-select-single:not(.ant-select-customize-input) {
    background: ${(props) => props.theme.colors.secondaryBg};
    &:not(.ant-select-status-error) {
      border: 1px solid ${(props) => props.theme.colors.primaryBorder};
    }
  }

  .ant-select:not(.ant-select-customize-input) {
    .ant-select-content-value,
    .ant-select-content-item,
    input.ant-select-input {
      color: ${(props) => props.theme.colors.primaryText};
    }
  }

  .ant-tabs-tab-btn {
    ${truncate()}
    color: ${(props) => props.theme.colors.primaryText};
  }

  .ant-tabs-ink-bar {
    display: none;
  }

  .ant-picker-datetime-panel {
    width: 100%;
  }

  .schedule-modal {
    .ant-modal-container {
      .ant-modal-body {
        padding: 48px 20px 0;
        margin-top: 0;
        min-height: 400px;
      }
      .schedule-input {
        visibility: hidden;
        height: 0;
      }
    }
  }

  .schedule-date-picker {
    width: 410px;

    .ant-picker-panel-container {
      border: 1px solid ${(props) => props.theme.colors.primaryBorder};
      border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
      box-shadow: none;
      margin-top: -40px;
    }

    .ant-picker-panel {
      width: 100%;
      border: none;

      .ant-picker-datetime-panel {
        font-size: ${(props) => props.theme.typography.fontSizeDefault};
      }

      .ant-picker-time-panel {
        width: 127.52px;

        .ant-picker-time-panel-column {
          overflow-y: auto;
        }

        .ant-picker-time-panel-column::after {
          height: auto;
        }
      }
    }
  }

  .account-modal-change-password {
    .ant-modal-body {
      padding: 3.43rem 3.43rem 0;
      ${media.sm`
        padding: 1.4rem 1.4rem 0;      
      `}
    }
  }

  .ant-select-option-indeterminate {
    &.ant-select-item-option:before {
      background: url(
      data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABHNCSVQICAgIfAhkiAAAAFRJREFUGFfdkMENQFAUBGc1ogRKUQoV0In8BvxW6OBrxEqE24s42+PsnEbMuUOMiJZopmAGkZYCqkPpgWYVKftVus+/iR/y4E1X8MoTqIkzeedQfwK2eiJeUuEXcQAAAABJRU5ErkJggg==
      ) no-repeat center;
      background-size: 50%;
    }
  }

  .ant-dropdown-menu-item.ant-dropdown-menu-item-only-child {
    div {
      font-size: ${(props) => props.theme.typography.fontSizeDefault};
    }
    &:not(.ant-dropdown-menu-item-disabled) {
      color: ${(props) => props.theme.colors.primaryText};
    }
  }

  .ant-form-item .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
    display: none;
  }

  .brand-settings.ant-layout-sider {
    .ant-menu {
      &.ant-menu-root .ant-menu-item {
        padding-left: 1.45rem !important;
      }

      svg {
        g rect {
          fill: none;
        }
      }
    }
  }

  aside li {
    user-select: none;
  }

  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background: none;
  }

  .ant-select-selection-search {
    color: ${(props) => props.theme.colors.primaryText};
  }

  .ant-menu.ant-menu-root .ant-menu-submenu.ant-menu-submenu-active .ant-menu-submenu-title span {
    span {
      color: ${(props) => props.theme.colors.hover};
    }
  }

  .ant-select-multiple {
    .ant-select-selection-placeholder {
        padding-left: 0.45rem;
    }
    .ant-select-selection-search {
        margin-left: 1.14rem;
    }
    .ant-select-selection-wrap .ant-select-selection-item {
        padding-left: 1.14rem;
    }
  }
  
  .rc-virtual-list-scrollbar {
    width: 0.43rem !important;
    height: 0.43rem !important;
  }

  .rc-virtual-list-scrollbar-thumb {
    border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall} !important;
    background-color: ${(props) => props.theme.colors.primaryBorder} !important;
  }

  .site-tree-search-value {
    color: #f50;
  }

  .ant-tabs-dropdown {
    min-width: 14.29rem;

    .ant-tabs-dropdown-menu {
      background: ${(props) => props.theme.colors.selectBg};
    }

    .ant-tabs-dropdown-menu-item {
      padding: 0.71rem 1.14rem;
      font-size: ${(props) => props.theme.typography.fontSizeDefault};

      &:hover {
        background: ${(props) => props.theme.colors.hoverBg};
      }
    }
  }

  .ant-btn:after {
    display: none;
  }
  
  .ant-btn.ant-btn-icon-only > span {
    transform: scale(1);
  }
  
  .anticon.anticon-search {
    font-size: 1.28rem;
  }

  .ant-input-group > .ant-input-affix-wrapper:not(:last-child) .ant-input {
    padding-right: 1.5rem;
  }

  .ant-input, .ant-input-affix-wrapper {
    border: 1px solid ${(props) => props.theme.colors.primaryBorder};
  }

  .ant-input-wrapper.ant-input-group,
  .ant-input-affix-wrapper.ant-input-search {
    height: 100%;
  }

  .ant-input-group {
    display: flex;
  }

  .ant-input-search > .ant-input-affix-wrapper {
    background: ${(props) => props.theme.colors.secondaryBg};
  }

  .ant-select {
    //padding-right: 2.85rem;
    font-size: 1rem;
    .ant-select-content {
        //height: 100%;
    }
    .ant-input-affix-wrapper.ant-input-outlined:focus-within {
      background-color: transparent;
    }
  }

  .ant-space-compact .ant-input-affix-wrapper:not(:last-child) {
    border-top-right-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
    border-bottom-right-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
    border: 1px solid ${(props) => props.theme.colors.primaryBorder};
  }

  .ant-input-search .ant-input-group .ant-input-affix-wrapper:not(:last-child) {
    border-top-left-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
    border-bottom-left-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
  }

  .ant-picker-range-arrow::after {
    border-color: ${(props) => props.theme.colors.tableTrEvenColor} ${(props) => props.theme.colors.tableTrEvenColor} transparent;
  }

  .ant-tabs {
    color: ${(props) => props.theme.colors.primaryText};
    
    .ant-tabs-tab {
      font-size: 1rem;
      border-bottom: 2px solid transparent;

      &-active {
        border-bottom: 2px solid ${(props) => props.theme.colors.blue};
      }
    }

    .ant-tabs-nav-operations {
      .ant-tabs-nav-more {
        color: ${(props) => props.theme.colors.primaryText};
      }
    }
  }

  .ant-list {
    .ant-list-item {
      color: ${(props) => props.theme.colors.primaryText};
    }
  }

  .ant-tabs-nav-wrap {
    ::-webkit-scrollbar {
      display: none;
    }

    ::-webkit-scrollbar-thumb {
      display: none;
    }
  }

  .ant-dropdown-menu-submenu-popup > .ant-dropdown-menu {
    width: 11.86rem;
  }

  .ant-dropdown .ant-dropdown-menu,
  .ant-dropdown-menu-submenu .ant-dropdown-menu,
  .ant-radio-inner {
    background-color: ${(props) => props.theme.colors.selectBg};
  }

  .ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {
    border-top-color: ${(props) => props.theme.colors.secondaryBg};
    border-left-color: ${(props) => props.theme.colors.secondaryBg};
  }

  .ant-picker-range {
    width: 100%;
  }

  .ant-dropdown-menu-submenu-popup li {
    > div {
      display: flex;
      justify-content: space-between;
    }

    &:hover {
      background: ${(props) => props.theme.colors.hoverBg};
    }
  }

  .ant-dropdown-menu-submenu-title {
    height: 2.57rem;

    &:hover {
      background: ${(props) => props.theme.colors.hoverBg};
    }
  }

  .ant-select-item-option-content {
    color: ${(props) => props.theme.colors.primaryText};
  }

  .hidden {
    display: none !important;
  }

  .content-overlay {
    width: 100%;
    background: ${(props) => props.theme.colors.secondaryBg};
    overflow: hidden;
    height: 100%;
    position: absolute;
    z-index: ${contentOverlayZIndex};
    opacity: 0.1;
  }

  .pdf-viewer-canvas {
    height: 28.5rem;
  }

  .read-more-popover .ant-popover-container {
    background: #4d4d4c;
    width: 20rem;
  }

  .read-more-popover .ant-popover-container p {
    color: ${(props) => props.theme.colors.secondaryBg};
  }

  //menu tooltip icon
  .ant-menu-inline-collapsed-tooltip .ant-tooltip-container div{
    span {
      opacity: 1;
    }  
    div {
      display: none;
    }
  } 

  .ant-menu-item.ant-menu-item-active:hover > div span {
    color: ${(props) => props.theme.colors.blue};
  }

  .ant-dropdown {
    &.fit-content {
      .ant-dropdown-menu-title-content {
        white-space: nowrap;
      }
    }

    .ant-dropdown-menu {
      .ant-dropdown-menu-item {
        font-size: 1rem;
        color: ${(props) => props.theme.colors.primaryText};
      }
    }
  }

  .ant-dropdown-menu-item:hover, .ant-dropdown-menu-submenu-title:hover {
    background-color: ${(props) => props.theme.colors.hoverBg};
  }

  .ant-menu-inline,
  .ant-menu-vertical,
  .ant-menu-vertical-left {
    border-right: none !important;
  }

  .ant-message {
    z-index: ${antMessageZIndex};

    .ant-message-notice-wrapper {
      .ant-message-notice-content {
        position: relative;
        border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
        padding-right: 46px;
        word-break: break-word;
        text-align: center;
        line-height: 22px;
        color: rgba(0,0,0,0.88);
        max-height: 90vh;
        overflow: auto;
      }
    }
  }

  .generate-image {
    width: 242px;
    height: 148px;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }

  .ant-select-multiple .ant-select-content {
    overflow: hidden;
    flex-wrap: nowrap;
    height: 100%;
  }

  .ant-empty {
    .ant-empty-description {
      font-size: 1rem;
      color: ${(props) => props.theme.colors.filterLabelColor};
    }
  }
  
  .ant-modal-root {
    .ant-modal-header .ant-modal-title {
      color: ${(props) => props.theme.colors.primaryText};
    }
      
    &.attachment-preview-popup {
      .ant-modal-wrap {
        max-width: calc(100vw - ${previewDetailsWrapperWidth}px);
        
        ${media.sm`
          max-width: 100%;
        `};
      }

      .ant-modal-close, .ant-modal-close:hover {
        position: fixed;
        right: calc(${previewDetailsWrapperWidth}px + 10px);
        top: 60px;
        background-color: rgba(0, 0, 0, 0.25);
        width: unset;
        height: unset;
        display: flex;
        color: ${(props) => props.theme.colors.white};
        border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusCircle};
        padding: 14px;
        border: 0;

        opacity: 0;
        animation: fade 0.3s forwards;
        animation-delay: 0.5s;
        
        @keyframes fade {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        svg g {
          stroke: #fff;
        }

        ${media.sm`
          right: 10px;
      `}
      }
    }
  }

  .ant-form-item-has-error .ant-input-affix-wrapper, .ant-form-item-has-error .ant-input-affix-wrapper:hover,
  .ant-form-item-has-error .ant-select:not(.ant-select-disabled):not(.ant-select-customize-input) .ant-select-selector {
    background: ${(props) => props.theme.colors.secondaryBg} !important;
  }

  .ant-input-affix-wrapper-disabled, .ant-select-disabled {
    background: ${(props) => props.theme.colors.grayButton} !important;
    border-color: ${(props) => props.theme.colors.primaryBorder} !important;
    border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
    pointer-events: none;

    .ant-select-selector {
      background: ${(props) => props.theme.colors.grayButton} !important;
      border-color: ${(props) => props.theme.colors.primaryBorder} !important;
    }
  }

  .ant-picker.ant-picker-range.ant-picker-disabled {
    background: ${(props) => props.theme.colors.grayButton};
    border-color: ${(props) => props.theme.colors.primaryBorder};
  }

  .ant-picker-input > input[disabled] {
    color: ${(props) => props.theme.colors.filterLabelColor};
  }

  .description-popover .ant-popover-container {
    padding: 0;
    max-width: 32rem;
  }

  .more-popover {
    padding-top: 0;

    .ant-popover-content {
      padding: 16px;
      font-size: ${(props) => props.theme.typography.fontSizeDefault};
      max-height: 12.7rem;
      overflow-y: auto;
    }
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    text-shadow: none;
  }

  .ant-radio {
    top: -0.1rem;
  }

  .ant-radio-wrapper {
    align-items: center;
    color: ${(props) => props.theme.colors.primaryText};
    margin-inline-end: 1.14rem;
  }

  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background: transparent;

    span {
      color: ${(props) => props.theme.colors.blue};
    }
  }

  .multi-select {
    .ant-select-item-option {
      padding-left: 2.86rem;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        left: 0.86rem;
        width: 16px;
        height: 16px;
        border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusDefault};
        border: 1px solid ${(props) => props.theme.colors.primaryBorder};
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .ant-select-item-option-selected {
      &:before {
        content: '';
        width: 16px;
        background-color: ${(props) => props.theme.colors.blue};
        border: 1px solid ${(props) => props.theme.colors.blue};
        background-image: url(${CheckPng});
        background-repeat: no-repeat;
        background-position: center;
      }
      &.ant-select-item-option-disabled:before {
        opacity: 0.5;
      }
    }

    .ant-select-item-option-disabled {
      .ant-select-item-option-content {
        color: ${(props) => props.theme.colors.secondaryColor};
      }

      &:before {
        border: 1px solid ${(props) => props.theme.colors.secondaryBorder};
      }
    }
  }
  
  .ant-select-arrow svg{
      fill: ${(props) => props.theme.colors.primaryText};
  }

  .no-padding-left:not(.ant-popover-container .no-padding-left) {
    padding-left: 0 !important;

    .ant-table-column-sorters {
      padding-left: 0 !important;
    }
  }

  .ant-form-item {
    .ant-form-item-label {
      font-size: 1rem;
      padding-bottom: 8px;

      & > label {
        font-size: 1rem;
      }
    }
  }

  .ant-menu-title-content,
  .ant-dropdown-menu-title-content {
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
  }

  .ant-picker-dropdown .ant-picker-panel-container,
  .ant-picker-ranges {
    background: ${(props) => props.theme.colors.selectBg};
    color: ${(props) => props.theme.colors.primaryText};
  }

  .ant-picker-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    .ant-picker-footer-extra {
      padding: 0 12px;
      border: none !important;

      > div {
        display: inline-block;
  
        &:hover {
          cursor: pointer;
        }
      }
    }
  }

  // .ant-form-item-control-input-content input.ant-input {
  //   border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
  // }

  //dark mode
  .ant-input-affix-wrapper > input.ant-input {
    color: ${(props) => props.theme.colors.primaryText};
  }

  .ant-form-item .ant-form-item-label > label {
    color: ${(props) => props.theme.colors.primaryText};
     &.ant-form-item-required ${StyledLabelInfoAndHint} {
        > div:first-child {
          ${truncate()}
          & > div:first-child {
            ${truncate()}
            &:after {
              content: '*';
              margin-left: 2px;
            }
          }
        }
      }
  }

  .ant-input-affix-wrapper > input.ant-input::placeholder {
    color: ${(props) => props.theme.colors.filterLabelColor};
  }

  .ant-form-item-has-error :not(.ant-input-disabled):not(.ant-input-borderless).ant-input {
    background: ${(props) => props.theme.colors.secondaryBg};

    &:hover {
      background: ${(props) => props.theme.colors.secondaryBg};
    }
  }

  .ant-select-item-empty {
    padding: 0.57rem 0.71rem;
    color: ${(props) => props.theme.colors.filterLabelColor};
  }

  .ant-input-number,
  .ant-input-number-handler-wrap,
  .ant-picker {
    background: ${(props) => props.theme.colors.secondaryBg};
    border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
    border-color: ${(props) => props.theme.colors.primaryBorder};
    
    &:hover {
      background: ${(props) => props.theme.colors.secondaryBg};
    }

    &:focus-within {
        background-color: transparent;
    }
  }

  .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab, .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab {
    background: ${(props) => props.theme.colors.primaryBg};
    border-bottom: 1px solid ${(props) => props.theme.colors.secondaryBorder};
  }

  .ant-tabs-dropdown {
    .ant-tabs-dropdown-menu-item {
      color:${(props) => props.theme.colors.primaryText};
    }
  }

  .ant-tabs-dropdown-menu-item {
    color: ${(props) => props.theme.colors.primaryText};
  }

  .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active, .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab-active {
    background: ${(props) => props.theme.colors.secondaryBg};
  }

  .ant-tabs-top > .ant-tabs-nav::before,
  .ant-tabs-bottom > .ant-tabs-nav::before,
  .ant-tabs-top > div > .ant-tabs-nav::before,
  .ant-tabs-bottom > div > .ant-tabs-nav::before {
    border-bottom: 1px solid ${(props) => props.theme.colors.secondaryBorder};
  }

  .ant-select-dropdown {
    background: ${(props) => props.theme.colors.selectBg};
  }
  
  .admin-tree-select-no-expand {
    padding: 0.57rem;
    .ant-select-tree {
      background-color: transparent;
      .ant-select-tree-list-holder-inner .ant-select-tree-treenode-active .ant-select-tree-node-content-wrapper {
          background-color: transparent;
      }
      .ant-select-tree-list-holder-inner .ant-select-tree-node-selected {
        background-color: transparent;
        font-weight: ${(props) => props.theme.typography.fontWeightMedium};
      }
      .ant-select-tree-node-content-wrapper {
        &:hover {
          background-color:  ${(props) => props.theme.colors.hoverBg};
        }
        .ant-select-tree-title {
          line-height: 2.28rem;
          color:${(props) => props.theme.colors.primaryText};
        }
      }
      .ant-select-tree-switcher {
        display: none;
      }
    }
  }

  .ant-picker-panel-container {
    .ant-picker-panel {
      background: ${(props) => props.theme.colors.selectBg};
    }
    .ant-picker-ranges {
      margin-left: auto;
      background: transparent;
    }
  }
  
  ${media.md`
    .ant-picker-dropdown {
      left: 50% !important;
      transform: translateX(-50%) !important;
      
      .ant-picker-range-wrapper {
        min-width: unset !important;
      }
      
      .ant-picker-panel-container {
        margin-left: 0 !important;
        .ant-picker-panel-layout {
          flex-wrap: wrap;
          flex-direction: column;        
        }
        .ant-picker-panels {
          flex-wrap: wrap;
        }
        
        .ant-picker-presets {
          width: 100%;
          max-width: 100%;
          ul {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 8px 0;
            height: auto;
            border: none;
            border-bottom: 1px solid rgba(0, 0, 0, 0.16);
            
            li {
              flex: 0 0 calc((100% / 3) - 6px);
              margin: 0 !important;
              border: 1px solid ${(props) => props.theme.colors.primaryBorder};
              text-align: center;
              font-size: 12px;             
            }
          }
        }
      }
    }
  `}

  .ant-picker-focused, .ant-input-group-wrapper .ant-input-affix-wrapper.ant-input-affix-wrapper-focused,
  .ant-input-affix-wrapper-focused {
    border: 1px solid ${(props) => props.theme.colors.blue};
  }

  .ant-form-item-has-error .ant-picker,
  .ant-picker:not(.ant-picker-disabled):not([disabled]).ant-picker-status-error,
  .ant-form-item-has-error .ant-picker.ant-picker-status-error.ant-picker-focused {
    background: ${(props) => props.theme.colors.secondaryBg};
  }

  .ant-input,
  .ant-input-number .ant-input-number-input,
  .ant-picker .ant-picker-input input {
    line-height: 2.28rem;
    color: ${(props) => props.theme.colors.primaryText};

    ::placeholder {
      color: ${(props) => props.theme.colors.filterLabelColor};
    }
  }

  .ant-select-selection-placeholder {
    color: ${(props) => props.theme.colors.filterLabelColor};
  }

  .ant-picker-header button {
    color: ${(props) => props.theme.colors.primaryText};
  }

  .ant-btn-primary[disabled], .ant-btn-primary[disabled]:hover, .ant-btn-primary[disabled]:focus, .ant-btn-primary[disabled]:active {
    background: ${(props) => props.theme.colors.secondaryBg};
    border: 1px solid ${(props) => props.theme.colors.primaryBorder};
    color: ${(props) => props.theme.colors.primaryText};
  }

  .ant-menu,
  .ant-drawer-content,
  .ant-drawer-header {
    background: ${(props) => props.theme.colors.selectBg};
  }

  .ant-checkbox-disabled + span {
    color: ${(props) => props.theme.colors.primaryText};
  }

  .ant-picker-dropdown {
    .ant-picker-cell.ant-picker-cell-in-view, .ant-picker-header-view,
    .ant-picker-time-panel-column > li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner {
      color: ${(props) => props.theme.colors.primaryText};
    }
    .ant-picker-presets {
      line-height: 1.57rem;
    }
    .ant-picker-time-panel-column > li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner:hover,
    .ant-picker-time-panel-column > li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {
      background: ${(props) => props.theme.colors.hoverBg};
    }
  }
  
  .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after,
  .ant-picker-cell:hover:not(.ant-picker-cell-in-view) .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-in-range::before,
  .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner::after,
  .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after,
  .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover::before,
  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single).ant-picker-cell-range-hover-start::before,
  .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after,
  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-end-single).ant-picker-cell-range-hover-start::before,
  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single).ant-picker-cell-range-hover-end::before,
  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,
  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before {
    background: ${(props) => props.theme.colors.hoverBg} !important;
  }

  .ant-picker-cell,
  .ant-picker-time-panel-column > li.ant-picker-time-panel-cell-disabled .ant-picker-time-panel-cell-inner,
  .ant-picker-time-panel-cell-disabled {
    color: ${(props) => props.theme.colors.primaryText};
    vertical-align: middle;
  }

  .ant-menu-item {
    &-selected {
      ${media.sm`
        pointer-events: none;
      `}
    }
    &:hover {
      span {
        color: ${(props) => props.theme.colors.blue};
      }
    }
  }

  .ant-form-item-has-error .ant-input, .ant-form-item-has-error .ant-input-affix-wrapper,
  .ant-form-item-has-error .ant-input:hover,
  .ant-form-item-has-error .ant-input-affix-wrapper:hover,
  .ant-form-item-has-error .ant-input-number:not([disabled]):hover,
  .ant-form-item-has-error .ant-picker:not([disabled]):hover {
    background: transparent;
  }

  .ant-form-item-has-error .ant-calendar-picker-open .ant-calendar-picker-input,
  .ant-form-item-has-error :not(.ant-input-affix-wrapper-disabled).ant-input-affix-wrapper-focused,
  .ant-form-item-has-error :not(.ant-input-affix-wrapper-disabled).ant-input-affix-wrapper:focus,
  .ant-form-item-has-error :not(.ant-input-disabled).ant-input-focused,
  .ant-form-item-has-error :not(.ant-input-disabled).ant-input:focus {
    box-shadow: none;
  }

  .ant-menu-submenu-popup.ant-menu-submenu > .ant-menu,
  .rc-virtual-list-holder-inner .ant-select-item.ant-select-item-option {
    background: ${(props) => props.theme.colors.selectBg};
  }

  .rc-virtual-list-holder-inner .ant-select-item.ant-select-item-option-active {
    background: ${(props) => props.theme.colors.hoverBg};
  }

  .ant-empty-image {
    svg g {
      path:nth-child(2),
      ellipse {
        fill: ${(props) => props.theme.colors.secondaryBorder};
      }

      g {
        stroke: ${(props) => props.theme.colors.filterLabelColor};
      }
    }
  }

  .ant-picker-cell:hover:not(.ant-picker-cell-selected):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):not(.ant-picker-cell-range-hover-start):not(.ant-picker-cell-range-hover-end) .ant-picker-cell-inner {
    background: ${(props) => props.theme.colors.hoverBg};
  }

  .ant-picker-dropdown .ant-picker-content th {
    color: ${(props) => props.theme.colors.filterLabelColor};
  }

  .ant-select-disabled .ant-select-selection-item {
    color: ${(props) => props.theme.colors.filterLabelColor};
  }

  // for expanded small table second td to have left position
  .ant-small-table-fix-left:not(.ant-table-small.ant-table-empty .ant-small-table-fix-left) {
    left: 38px !important;
    @media (max-width: 1366px) {
      left: 35px !important;
    }
  }

  // Dashboard widgets drawer
  .dashboard-widget-drawer {
    top: 6.85rem !important;
    height: calc(100vh - 75px);

    .ant-drawer-header {
      border-radius: 10px 10px 0 0;
      padding: 1.14rem 1.14rem 1.71rem;
      border-bottom: none;

      &-title {
        width: 100%;
      }
    }

    .ant-drawer-close {
      cursor: default;
      padding: 0;
      width: 100%;
      margin-right: 0;
      
      &:hover {
        background-color: transparent;
      }
    }

    .ant-drawer-body {
      background-color: ${(props) => props.theme.colors.selectBg};
      overflow: hidden;
      padding: 0;
    }

    .ant-drawer-section {
      border-radius: 10px 10px 0 0;

      &-wrapper {
        border-radius: 10px 10px 0 0;
      }
    }
  }
    
  .tox.tox-tinymce-aux {
    z-index: ${toxEditorZIndex};
  }
  
  .ant-color-picker {
    .ant-segmented-item {
      &:not(.ant-segmented-item-selected):not(.ant-segmented-item-disabled):hover,
      &.ant-segmented-item-selected {
        color: ${(props) => props.theme.colors.primaryText};
      }
    }
    .ant-input-number-actions {
      background-color: ${(props) => props.theme.colors.selectBg};
    }
    .ant-color-picker-steppers input {
      line-height: 1.2rem;
    }
  }
`;
export default Global;
